import React from 'react';
import { Link } from 'react-router-dom';

export const Privacy: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0a] p-4 sm:p-8 pb-16">
      <div className="max-w-2xl mx-auto">
        <Link to="/" className="text-gray-500 hover:text-white text-sm mb-8 inline-block">&larr; Tilbake</Link>

        <h1 className="text-2xl font-bold text-white mb-6">Personvern</h1>
        <div className="text-gray-300 text-sm leading-relaxed space-y-4">
          <p className="text-gray-500 text-xs">Sist oppdatert: 15. april 2026</p>

          <p>
            Scenechat drives av KW Productions AS (org.nr. 927 089 505), Ødderøyveien 47, 4610 Kristiansand S.
            Kontakt: kyrre@scenechat.no
          </p>

          <h2 className="text-lg font-semibold text-white pt-2">Hva vi samler inn</h2>
          <p>
            Når du sender inn et forslag, en stemme eller en melding via Scenechat, lagrer vi teksten du skriver og tidspunktet.
            Hvis du fyller inn navn, lagres det sammen med forslaget. Navn er alltid valgfritt.
          </p>

          <h2 className="text-lg font-semibold text-white pt-2">Hva vi ikke samler inn</h2>
          <p>
            Vi samler ikke inn e-post, telefonnummer, IP-adresse, lokasjon, enhetsdata eller annen identifiserende informasjon.
            Vi bruker ingen cookies og ingen sporingsverktøy (ingen Google Analytics, ingen Meta Pixel).
          </p>

          <h2 className="text-lg font-semibold text-white pt-2">Hvor dataen lagres</h2>
          <p>
            Data lagres hos Supabase i EU. Vi selger ikke data til tredjeparter og deler ikke data med annonsører.
          </p>

          <h2 className="text-lg font-semibold text-white pt-2">Hvor lenge vi lagrer data</h2>
          <p>
            Innsendte forslag slettes automatisk etter 90 dager. Arrangør kan også slette forslag manuelt når som helst.
          </p>

          <h2 className="text-lg font-semibold text-white pt-2">Dine rettigheter</h2>
          <p>
            Du har rett til innsyn, retting og sletting av dine data (GDPR art. 15–17).
            Kontakt oss på kyrre@scenechat.no. Oppgi teksten du sendte inn og omtrentlig tidspunkt, så finner vi den.
          </p>
          <p>
            Du kan også klage til Datatilsynet (datatilsynet.no).
          </p>

          <h2 className="text-lg font-semibold text-white pt-2">Rettslig grunnlag</h2>
          <p>
            Vi behandler data basert på berettiget interesse (GDPR art. 6(1)(f)). Du sender frivillig inn tekst til en arrangør.
            Ingen innlogging eller registrering kreves.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;